import React from 'react'
import './index.scss'

const RestrictedRightsholderPopup = () => (
    <div className="rightsholder-restricted-modal-container">
        <p>Before you can access The MLC Portal please update your banking and tax information.</p>
        <p>
            You can find step-by-step instructions on how to do update this information by clicking
            <a href="https://help.themlc.com/en/support/setting-up-banking-and-tax-information"> here </a>
            to visit our HelpCenter.
        </p>
        <p>
            Once you have updated your information, please allow 24-48 hours for it to be validated through our payment
            processor.
        </p>
    </div>
)

export default RestrictedRightsholderPopup
